import { render } from "./DayViewWorkAreaGrid.vue?vue&type=template&id=34fa74a6"
import script from "./DayViewWorkAreaGrid.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaGrid.vue?vue&type=script&lang=ts"
script.render = render

export default script